import { gql } from 'apollo-boost';
import { getClient } from './client';

export default function doQuery(query) {
  return getClient().query({
    query: gql(query)
  });
}



// WEBPACK FOOTER //
// ./src/graphql/query.js